import { observer } from 'mobx-react-lite'
import React from 'react'
import { Image, Platform, StyleSheet, TouchableOpacity, View } from 'react-native'
import { Divider, List } from 'react-native-paper'

import { DS } from '../../design-system'
import { fontFamily } from '../../theme'
import GreenTickIcon from './assets/green-tick.svg'

export const TaskList = observer(
  ({
    title,
    subTitle,
    leftIcon,
    isTaskCompleted,
    onTaskSelected
  }: {
    title: string
    subTitle: string
    leftIcon: string
    isTaskCompleted: boolean
    onTaskSelected: () => void
  }) => {
    return (
      <TouchableOpacity onPress={onTaskSelected} style={styles.taskRow}>
        <View style={styles.taskIconContainer}>
          {isTaskCompleted ? (
            <GreenTickIcon />
          ) : (
            <Image source={{ uri: leftIcon }} resizeMode="cover" style={{ width: 65, height: 65 }} />
          )}
        </View>
        <View style={styles.taskDetailContainer}>
          <DS.Text variant="Caption/Regular" style={{ color: DS.palette['Brand/Dark Grey'] }}>
            {subTitle}
          </DS.Text>
          <DS.Text style={styles.containerPadding} numberOfLines={2} variant="Body Medium/Medium">
            {title}
          </DS.Text>
        </View>
        <View style={styles.taskRightContainer}>
          <List.Icon icon={'chevron-right'} color={DS.palette['Global/Black']} />
        </View>
      </TouchableOpacity>
    )
  }
)

const styles = StyleSheet.create({
  taskSubTitle: { color: DS.palette['Brand/Dark Grey'], fontSize: 12, fontFamily: fontFamily.GTAmericaStandardRegular },
  taskLeftIcon: {
    alignSelf: 'center',
    width: '100%',
    height: '100%',
    marginTop: 5
  },
  taskDetailContainer: {
    flex: 4.5,
    paddingLeft: 16
  },
  taskRightContainer: {
    flex: 0.5,
    alignItems: 'flex-end'
  },
  containerPadding: {
    // paddingHorizontal: DS.spacing[16]
  },
  taskRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  taskIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 65,
    width: 65,
    borderRadius: 35,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 2
  },
  taskTitle: { color: DS.palette['Global/Black'], fontSize: 16, fontFamily: fontFamily.GTAmericaStandardMedium },
  taskIconContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 10
  }
})
